import { render, staticRenderFns } from "./HitsTable.vue?vue&type=template&id=31c26077"
import script from "./HitsTable.vue?vue&type=script&lang=ts"
export * from "./HitsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports